import { ColorSettings, MeasureTableRow } from './dataTypes';
import {
  getActualAge,
  getActualSex,
  getActualRace,
  getActualEthnicity,
} from '../api/calls';

export const convertMeasureTableRowToMeasure = (row: MeasureTableRow) => {
  return {
    measureName: row["Measure"],
    actualScore: row["Score"],
    percentileRank: row["Percentile"] ? row["Percentile"] : null,
    correlationPercent: row["Positive Diagnosis Correlation"] ? row["Positive Diagnosis Correlation"] : null,
  };
};

export const roundToDecimal = (num: number, places: number) => {
  const factor = Math.pow(10, places);
  return Math.round(num * factor) / factor;
};

export const getColorGradient = (value: number): ColorSettings => {
  let textColor = 'black';
  let backgroundColor;
  if (value < 10) {
    textColor = 'white';
    backgroundColor = 'rgba(251, 86, 7, 255)';
  } else if (value < 20) {
    textColor = 'white';
    backgroundColor = 'rgba(244, 112, 68, 255)';
  } else if (value < 30) {
    backgroundColor = 'rgba(252, 168, 94, 255)';
  } else if (value < 40) {
    backgroundColor = 'rgba(253, 191, 111, 255)';
  } else if (value < 50) {
    backgroundColor = 'rgba(254, 220, 157, 255)';
  } else if (value < 60) {
    backgroundColor = 'rgba(206, 244, 124, 255)';
  } else if (value < 70) {
    backgroundColor = 'rgba(191, 253, 100, 255)';
  } else if (value < 80) {
    backgroundColor = 'rgba(138, 252, 60, 255)';
  } else if (value < 90) {
    textColor = 'white';
    backgroundColor = 'rgba(70, 200, 60, 255)';
  } else {
    textColor = 'white';
    backgroundColor = 'rgba(29, 181, 6, 255)';
  }
  return {color: textColor, backgroundColor: backgroundColor};
}

/* TODO: Implement a smoother color transition system,
 *       such as from this code that I grabbed from the backend. */

// def get_odds_ratio_colors() -> list[str]:
//     odds_ratios = get_odds_ratios()
//     odds_ratios = [min(max(x, 0.5), 2.0) for x in odds_ratios]
    
//     # Create a normalizer that maps real odds to 0–1
//     norm = Normalize(vmin=0.5, vmax=2.0)
    
//     # Dark Green -> Light Green -> White -> Light Red -> Dark Red
//     anchor_values = list(map(norm, [0.5, 0.8, 1.0, 1.2, 2.0]))
//     anchor_colors = ["#2ecc71", "#a9dfbf", "#ffffff", "#f5b7b1", "#e74c3c"]
    
//     # Colormap
//     cmap = LinearSegmentedColormap.from_list("odds_colormap", list(zip(anchor_values, anchor_colors)))

//     odds_ratio_colors = [to_hex(cmap(norm(x))) for x in odds_ratios]
//     return odds_ratio_colors

export const buildFilterParams = async (populationType: string) => {
  // default: no filtering
  const equal: Record<string, string | number> = {};
  switch (populationType) {
    case 'Age': {
      const age = await getActualAge();
      if (age != null) equal['Age'] = age;
      break;
    }
    case 'Sex': {
      const sex = await getActualSex();
      if (sex) equal['Sex'] = sex;
      break;
    }
    case 'Race': {
      const race = await getActualRace();
      if (race) equal['Race'] = race;
      break;
    }
    case 'Ethnicity': {
      const eth = await getActualEthnicity();
      if (eth) equal['Ethnicity'] = eth;
      break;
    }
    default: {}
  }
  return { lessThan: {}, greaterThan: {}, equal };
};